import useStyles from '../../theme/useStyles';
import { Rating } from '@mui/material';


const RatingComponent = ({ value, cantidad, dataItem, handleDataUpdate }) => {
    const classes = useStyles();

    return (
      <div className={classes.rootRating}>
          <Rating name="read-only" value={dataItem.promedio} readOnly />
          {dataItem.cantidadRegistros && <span>({dataItem.cantidadRegistros})</span>}
      </div>
    );
};

export default RatingComponent;
